import React from "react";
import { Link } from "react-router-dom";

const PricingDropdown: React.FC = () => {
  return (
    <li className="nav-item dropdown">
      <Link
        className="nav-link dropdown-toggle"
        to="#"
        id="navbarDropdownMenuLink"
        role="button"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        Pricing
      </Link>
      <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
        <Link className="dropdown-item" to="/membership">
          Membership
        </Link>
        <Link className="dropdown-item" to="/packages">
          Packages
        </Link>
      </div>
    </li>
  );
};

export default PricingDropdown;
